module.exports = "/images/vendor/flag-icon-css/flags/4x3/om.svg?1798270ba5e7dc130458959dccc26b22";